"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ICON_CLASSNAMES", {
  enumerable: true,
  get: function get() {
    return _manifest_icons["default"];
  }
});
exports["default"] = void 0;
Object.defineProperty(exports, "getLessCdnUrl", {
  enumerable: true,
  get: function get() {
    return _getLessCdnUrl.getLessCdnUrl;
  }
});
var _manifest_css = _interopRequireDefault(require("../manifest_css"));
var _manifest_icons = _interopRequireDefault(require("../manifest_icons"));
var _getLessCdnUrl = require("./getLessCdnUrl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _manifest_css["default"];